var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.09 17.307l.283.018c1.622.05 3.125.858 4.055 2.18-1.468.897-2.372 2.48-2.394 4.195.002 1.939 1.17 3.689 2.966 4.444-.345 1.116-.866 2.17-1.543 3.124-.908 1.352-1.861 2.673-3.373 2.697-1.47.034-1.964-.86-3.649-.86-1.7 0-2.227.836-3.636.894-1.44.053-2.541-1.443-3.483-2.782-1.882-2.734-3.348-7.706-1.383-11.089.923-1.649 2.648-2.695 4.545-2.756 1.441-.03 2.78.968 3.666.968.87 0 2.523-1.193 4.23-1.015zM29.39 12c.098 1.277-.308 2.542-1.132 3.527-.8.989-2.012 1.559-3.289 1.546-.081-1.24.337-2.463 1.162-3.396.836-.947 2-1.545 3.26-1.677z",
    transform: "translate(-908 -791) translate(876 710) translate(16 69)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.3599f704.svg";
export { ForwardRef as ReactComponent };